import React from 'react';

interface IconToggleSliderProps {
    iconClasses?: string;
}

const IconToggleSlider: React.FC<IconToggleSliderProps> = ({ iconClasses }) => {
    return (
        <svg
            width="21"
            height="13"
            viewBox="0 0 21 13"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={`icon icon-toggle-slider ${iconClasses ?? ''}`}
        >
            <path
                d="M14.875 0C18.2577 0 21 2.74226 21 6.125C21 9.50775 18.2577 12.25 14.875 12.25H6.125C2.74226 12.25 0 9.50775 0 6.125C0 2.74226 2.74226 0 6.125 0H14.875ZM6.125 1.75C3.70876 1.75 1.75 3.70876 1.75 6.125C1.75 8.54123 3.70876 10.5 6.125 10.5H14.875C17.2912 10.5 19.25 8.54123 19.25 6.125C19.25 3.70876 17.2912 1.75 14.875 1.75H6.125ZM6.125 3.5C7.57474 3.5 8.75 4.67521 8.75 6.125C8.75 7.57479 7.57474 8.75 6.125 8.75C4.67526 8.75 3.5 7.57479 3.5 6.125C3.5 4.67521 4.67526 3.5 6.125 3.5Z"
                fill="currentColor"
            />
        </svg>
    );
};

export default IconToggleSlider;
